// extracted by mini-css-extract-plugin
module.exports = {"navCont":"_27gNGY0eXZeRu0pEgqXQcT","navDot":"_1Iw2Y6yZNrGEV-tPpeoP35","selected":"_1AbH6UmXwiPl0TeCAhBzZv"};